import apiClient from "./apiClient";


const statistics = [
    { number: 50, suffix: "+", label: "Projects Delivered" },
    { number: 30, suffix: "+", label: "Happy Clients" },
    { number: 4, suffix: "+", label: "Years in Business" },
    { number: 100, suffix: "%", label: "Client Satisfaction" },
  ];


export const getStatistics = async () => {
  try {
    const response = await apiClient.get("/statistics");
    return response.data;
  } catch (error) {
      console.error("Error fetching statistics:", error);
      //throw error; // rethrow so component can handle it
      return statistics;
  }
};
